import Link from 'next/link';

import Button from '@common/Button/Button';
import { HomeFeaturedArticleType } from '@nextTypes/guides';
import { RecipesAndGuidesContainer } from '@components/RecipesAndGuides/RecipesAndGuidesContainer';
import { createImageCards } from './RecipesAndGuidesUtils';

type Props = {
  articles: HomeFeaturedArticleType[];
};

export const RecipesSection = ({ articles }: Props): JSX.Element => {
  const cards = createImageCards(articles, 6);
  return (
    <RecipesAndGuidesContainer
      backgroundColour="bg-dawn-blue-100"
      buttonColour="NavyBlue"
      categoryTitle="Recipes"
      categoryTitleColour="text-blue"
      cta="More Recipes"
      ctaColour="text-blue"
      href="/guides/category/recipes"
      description="Learn how to cook your own healthy and satisfying meals using the latest recipes from Second Nature - developed and curated by our nutritionists and dietitians."
      descriptionColour="text-blue"
    >
      <div className="flex flex-col items-center">
        <div className="m-auto mb-8 grid grid-cols-1 justify-items-center gap-6 lg:mb-12 lg:grid-cols-2">
          {cards}
        </div>
        <div className="mb-14 lg:mb-0">
          <Link href="/guides/category/recipes">
            <Button colour="NavyBlue" type="Secondary">
              More recipes
            </Button>
          </Link>
        </div>
      </div>
    </RecipesAndGuidesContainer>
  );
};
